import React, { useContext, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { modelDetailsServiceTabReports } from "constants/ReportTypes";
import { ReportFormats } from "constants/reportSubscriptions";
import {
	ReportGenerationDialog,
} from "components/Modules/ReportSubscriptions";
import {
	toApiOutputFormat,
	toApiReportType,
} from "services/reportSubscriptions";
import { ModelContext } from "contexts/ModelDetailContext";
import PrintIcon from "assets/printer.svg";
import CommonDropdown from "components/Elements/CommonDropdown";

const useStyles = makeStyles()(() => ({
	mainContainer: {
		display: "flex",
		gap: "1rem",
	},
	dropdownContainer: {
		width: "16rem",
	},
}));

// Maps the legacy "tasksExcel" UI key to the canonical backend ReportType
// alias. modelDetailsServiceTabReports.tasksExcel exists for backwards-compat
// with the dropdown labels; the BGP enum value is "modelTask".
const REPORT_TYPE_TO_API_KEY = {
	[modelDetailsServiceTabReports?.toolsSummary]: "toolsSummary",
	[modelDetailsServiceTabReports?.toolsByTask]: "toolsByTask",
	[modelDetailsServiceTabReports?.partsSummary]: "partsSummary",
	[modelDetailsServiceTabReports?.partsByTask]: "partsByTask",
	[modelDetailsServiceTabReports?.serviceSheet]: "serviceSheet",
	[modelDetailsServiceTabReports?.tasksExcel]: "modelTask",
};

const ReportDropdowns = ({ customCaptions }) => {
	const ModelCtx = useContext(ModelContext);
	const { classes } = useStyles();
	const [activeReportRequest, setActiveReportRequest] = useState(null);

	const closeReportDialog = () => setActiveReportRequest(null);

	const reports = [
		{
			id: "1",
			name: `${customCaptions?.toolPlural || "Tools"} Summary`,
			reportType: modelDetailsServiceTabReports?.toolsSummary,
			format: ReportFormats.PDF,
		},
		{
			id: "2",
			name: `${customCaptions?.partPlural || "Parts"}  Summary`,
			reportType: modelDetailsServiceTabReports?.partsSummary,
			format: ReportFormats.PDF,
		},
		{
			id: "3",
			name: `${customCaptions?.partPlural || "Parts"} by ${
				customCaptions?.task || "Task"
			}`,
			reportType: modelDetailsServiceTabReports?.partsByTask,
			format: ReportFormats.PDF,
		},
		{
			id: "4",
			name: `${customCaptions?.toolPlural || "Tools"} by ${
				customCaptions?.task || "Task"
			}`,
			reportType: modelDetailsServiceTabReports?.toolsByTask,
			format: ReportFormats.PDF,
		},
		{
			id: "5",
			name: `${customCaptions?.service || "Service"} Sheet `,
			reportType: modelDetailsServiceTabReports?.serviceSheet,
			format: ReportFormats.PDF,
		},
		{
			id: "6",
			name: `${customCaptions?.taskPlural || "Tasks"} Excel `,
			reportType: modelDetailsServiceTabReports?.tasksExcel,
			format: ReportFormats.Excel,
		},
	];

	const payload = ModelCtx?.[0]?.serviceLayoutDetails;

	const downloadReportHandler = (reportToBeDownloaded, handleClose) => {
		if (Object.keys(reportToBeDownloaded)?.length < 1) return;
		handleClose();

		const apiTypeKey = REPORT_TYPE_TO_API_KEY[reportToBeDownloaded.reportType];
		if (!apiTypeKey) return;

		setActiveReportRequest({
			reportName: reportToBeDownloaded.name,
			format: reportToBeDownloaded.format,
			body: {
				reportType: toApiReportType(apiTypeKey),
				outputFormat: toApiOutputFormat(reportToBeDownloaded.format),
				filterContext: payload || {},
				name: null,
				recipientEmail: null,
				sendEmail: false,
			},
		});
	};

	return (
		<div className={classes.mainContainer}>
			<CommonDropdown
				iconSrc={PrintIcon}
				isDownloading={false}
				dataSource={reports}
				dynamicAction={downloadReportHandler}
			/>
			{activeReportRequest ? (
				<ReportGenerationDialog
					open
					onClose={closeReportDialog}
					reportName={activeReportRequest.reportName}
					format={activeReportRequest.format}
					body={activeReportRequest.body}
				/>
			) : null}
		</div>
	);
};

export default ReportDropdowns;
